export const SITE = {
  name: "MediEste Estetik & Güzellik",
  shortName: "MediEste",
  phone: "0545 656 97 47",
  phoneRaw: "+905456569747",
  whatsapp: "905456569747",
  email: "info@medieste.com",
  address: "Bağlıca Bulvarı, Mert Caddesi, No:4/2 Mermer Plaza Kat:1 Etimesgut / Ankara",
  addressShort: "Bağlıca / Etimesgut, Ankara",
  mapUrl: "https://www.google.com/maps?q=Ba%C4%9Fl%C4%B1ca%20Bulvar%C4%B1%20Mert%20Caddesi%20No:4/2%20Etimesgut%20Ankara",
  socials: {
    instagram: "https://www.instagram.com/mediestebeauty/",
    facebook: "https://www.facebook.com/mediestebeauty/",
  },
  hours: "Pzt-Cmt 09:00 – 19:00 | Pzr Kapalı",
  origin: "https://www.medieste.com",
};

export const waHref = (msg) => {
  let finalMsg = msg;
  if (!finalMsg) {
    const path = typeof window !== "undefined" ? window.location.pathname : "";
    const title = typeof document !== "undefined" ? document.title.split(" | ")[0] : "";
    
    if (path.startsWith("/urun/") || path.startsWith("/hizmet/") || path.startsWith("/blog/")) {
      if (title && title !== "MediEste" && title !== "Ayak Sağlığı ve Dermokozmetik Ürünleri" && title !== "Hizmetlerimiz") {
        finalMsg = `Merhaba, "${title}" hakkında bilgi almak istiyorum.`;
      } else {
        finalMsg = "Merhaba, bu sayfa içeriği hakkında bilgi almak istiyorum.";
      }
    } else if (path === "/hizmetlerimiz") {
      finalMsg = "Merhaba, hizmetleriniz hakkında bilgi almak istiyorum.";
    } else if (path === "/ayak-sagligi-urunleri") {
      finalMsg = "Merhaba, ayak sağlığı ürünleriniz hakkında bilgi almak istiyorum.";
    } else if (path === "/iletisim") {
      finalMsg = "Merhaba, iletişim ve konum hakkında bilgi almak istiyorum.";
    } else if (path === "/hizli-randevu") {
      finalMsg = "Merhaba, randevu almak istiyorum.";
    } else {
      finalMsg = "Merhaba, MediEste hakkında bilgi almak istiyorum.";
    }
  }
  return `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(finalMsg)}`;
};
